<template>
  <v-container v-if="this.zamawiajacy" class="page">
    <table>
      <thead>
        <tr>
          <td>

            <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
              <div class="left-cointainer">
                <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
              </div>
              <div class="right-cointainer">
                Tutore Sp. z o.o.<br>
                ul. Piotrkowska 157A, 90-440 Łódź<br>
                NIP: 7272846163
              </div>
            </div>

          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>

            <p align="center" style="margin-top:20px;">
              <strong>UMOWA ZLECENIE {{ shortNrUmowy() }}</strong>
            </p>
            <p>
              Zawarta w Łodzi pomiędzy:
            </p>
            <p><strong>Zleceniodawcą:</strong></p>
            <p>
              <strong>Tutore Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia w
Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS: 0000867745, NIP: 7272846163, REGON: 387448002,
kapitał zakładowy 5.000,00 zł, reprezentowaną przez:
            </p>
            <p><b>{{ zamawiajacy }}</b></p>
            <p>a</p>
            <p>
              <strong>Zleceniobiorcą:</strong>
            </p>
            <p>Imię i nazwisko: {{ imieNazwisko }}</p>
            <p>Pesel: {{ pesel }}</p>
            <p>Adres: {{ zamieszkany }}</p>

            <p align="center" style="margin-top: 10px;"><strong>Warunki umowy</strong></p>

            <p align="center">
              <strong>§ 1 Przedmiot umowy</strong>
            </p>
            <ol>
              <li>Na podstawie niniejszej umowy Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności (zwanych w dalszej części Umowy Zleceniami) jak:
                <ol>
                  <li>rzetelne przygotowanie i prowadzenie zajęć stacjonarnych dla wszystkich uczestników kursów organizowanych przez Zleceniodawcę,  w ramach kursów organizowanych przez Zleceniodawcę lub podmiot wskazany przez Zleceniodawcą, zgodnie z programem edukacyjnym wskazanym przez Zleceniodawcę oraz harmonogramem zajęć (który może mieć formę zapisu elektronicznego);</li>
                  <li>prowadzenie/animowanie zajęć interaktywnych;</li>
                  <li>rzetelne prowadzenie dokumentacji potwierdzającej realizację zajęć, zawierającej w szczególności: dzienniki zajęć, listy obecności, dokumentację dotyczącą ewaluacji uczniów, sprawozdania z realizacji zajęć oraz raportów wymaganych przez Klientów B2B - w formie oraz terminach ustalonych przez Zleceniodawcę;</li>
                  <li>terminowe wykonywanie wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
                  <li>prowadzenie zajęć odrobieniowych jeżeli zajdzie potrzeba ich przeprowadzenia;</li>
                  <li>dbanie o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;</li>
                  <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę;</li>
                  <li>regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
                    <ol type="a">
                      <li>przekazywanie niezbędnych informacji w zakresie określonym w danej sytuacji;</li>
                      <li>udział w zebraniach, rozmowach wizytacyjnych i ewaluacjach;</li>
                    </ol>
                  </li>
                  <li>współpraca z kursantami lub w przypadku uczniów niepełnoletnich - ich rodzicami lub opiekunami prawnymi w tym szczególnie udzielanie niezbędnych informacji dotyczących usługi (np. przekazywanie prac domowych, sprawdzanie i przekazywanie raportów z postępów uczniów);</li>
                  <li>udział w spotkaniach lub zebraniach, w określonych przez Zleceniodawcę terminach;</li>
                  <li>realizacja zleceń dotyczących promocji, sprzedaży i obsługi Klientów w miejscach wskazanych przez Zleceniobiorcę;</li>
                  <li>realizacja zadań promocyjnych, marketingowych i organizacyjnych (animator);</li>
                  <li>realizacja innych zadań i projektów zleconych przez Zleceniodawcę;</li>
                </ol>
              </li>
              <li>Celem zapewnienia warunków do wykonania niniejszej Umowy, Zleceniodawca zobowiązuje się do udostępnienia     
    aktualnie posiadanych materiałów dydaktycznych. Powyższe nie obejmuje sprzętu elektronicznego (komputer,   
    sprzęt nagłaśniający, internet itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 2 Wykonywanie umowy</strong>
            </p>
            <ol>
              <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością i swoją najlepszą wiedzą.</li>
              <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się może w formule stacjonarnej w wybranej placówce Zleceniodawcy wskazanej przez Zleceniodawcę albo u Klienta w miejscu wskazanym przez Zleceniodawcę. Forma prowadzenia zajęć określona zostanie w harmonogramie zajęć. Zleceniodawca umożliwi Zleceniobiorcy korzystanie z platform niezbędnych do prowadzenia zajęć.</li>
              <li>Strony ustalają, iż za jednostkę obliczeniową przyjmuje się:
                <ol type="a">
                  <li>w przypadku nauczycieli/lektorów prowadzących zajęcia stacjonarne - 45 minut zajęć według ustalonego harmonogramu.</li>
                  <li>w przypadku animatorów pełniących funkcje dydaktyczne - 45 minut zajęć według ustalonego harmonogramu.</li>
                  <li>w przypadku animatorów pełniących funkcje organizacyjne - 60 minut według ustalonego    
                harmonogramu.</li>
                </ol>
              </li>
              <li>Łączny wymiar godzin do wykonania będzie określony w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.</li>
              <li>Strony dopuszczają zmianę dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.</li>
              <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
              <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 3 Obowiązek informacyjny</strong>
            </p>
            <ol>
              <li>
                Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy oraz poszczególnych Zleceń.
              </li>
              <li>
                Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy oraz poszczególnych Zleceń.
              </li>
            </ol>
            <br>
            <br>

            <p align="center">
              <strong>§ 4 Absencje i powiadamianie o nich</strong>
            </p>
            <ol>
              <li>W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 7 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.</li>
              <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, 
Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia powiadomić o takiej sytuacji Zleceniodawcę. </li>
              <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, 
Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia, jednak zobowiązany jest do poinformowania Zleceniodawcy niezwłocznie po zaistnieniu takiego zdarzenia. Zleceniobiorca potwierdza to, na podstawie e-zwolnienia lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE ZUS.</li>
              <li>W przypadku nie przeprowadzenia zajęć w terminie wynikającym z harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 7 dni przed planowanymi zajęciami, Zleceniodawca może rozwiązać umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. W takim przypadku, niezależnie od możliwości wypowiedzenia umowy, Zleceniodawca może ponadto dochodzić kary umownej w wysokości 5 000 zł (słownie: pięć tysięcy złotych) od Zleceniobiorcy za poniesione straty. Zleceniodawca może także dochodzić odszkodowania przenoszonego wartość zastrzeżonej kary umownej. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przeprowadzenia zajęć.</li>
              <li>W przypadku niemożności przeprowadzenia przez Zleceniobiorcę zajęć zaplanowanych według harmonogramu i niemożliwości znalezienia zastępstwa przez Zleceniodawcę, Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nieodbytym zajęciom ( tzw. zajęcia odrobieniowe § 1 ust. 5)  w innym terminie uzgodnionym pisemnie ze Zleceniodawcą.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
            </p>
            <ol>
              <li>Strony zawierają umowę na czas określony, od {{ dataObowiazywaniaUmowyPolski() }} do dnia {{ umowaDo !== '30-12-1899' ? umowaDo : '31-08-2024' }} r.</li>
              <li>Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem ust. 3 niniejszego paragrafu).</li>
              <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia w przypadkach wskazanych w Umowie, a także w sytuacji braku możliwości powierzenia przedmiotu niniejszej umowy lub jeżeli Zleceniobiorca narusza postanowienia niniejszej Umowy, przez co strony rozumieją w szczególności:
                <ol type="a">
                  <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków lub Zleceń określonych w § 1 ust. 1 Umowy pomimo   uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
                  <li>naruszenia przez Zleceniobiorcę zakazu konkurencji,</li>
                  <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych.</li>
                </ol>
              </li>
              <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę umowną w wysokości 20 000 PLN. Zleceniodawca może także dochodzić odszkodowania przenoszącego wartość zastrzeżonej kary umownej.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 6 Wynagrodzenie</strong>
            </p>
            <ol>
              <li>
                Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Umowy oraz powierzonych Zleceniobiorcy Zleceń, Zleceniobiorca otrzyma wynagrodzenie  w wysokości:
                <ol type="a">
                  <li>usługa “lektor/nauczyciel zajęcia stacjonarne” {{ stawka }} zł (słownie: {{ stawkaSlownie }} złotych) brutto za jedną godzinę rozumianą zgodnie z § 2 ust. 3.</li>
                  <li>usługa “animator zajęcia dydaktyczne” 30 zł (słownie: trzydzieści złotych) brutto za jedną godzinę  rozumianą zgodnie z § 2 ust. 3.</li>
                  <li>usługa “animator zajęcia organizacyjne” 30 zł (słownie: trzydzieści .złotych) brutto za jedną godzinę  rozumianą zgodnie z § 2 ust. 3.</li>
                </ol>
              </li>
              <li>W przypadku Zleceniobiorców świadczących Zlecenie wyszczególnionych w§ 6 pkt.1 a) i b) do obliczania wysokości wynagrodzenia dodatkowo zastosowanie ma poniższa <em>Tabela nr.1:Taryfikator stawek dla zajęć stacjonarnych w szkołach podstawowych w projekcie Back to School</em>
              
                <table class="wage-table">
                  <caption>Tabela nr.1 Taryfikator stawek dla zajęć stacjonarnych w szkołach podstawowych w projekcie Back to School</caption>
                  <tr>
                    <th>Ilość obecnych aktywnych uczestników kursu</th>
                    <th>Stawka brutto lektor/nauczyciel dla kursu stałego 45 min</th>
                    <th>Stawka brutto animator dla kursu stałego 60 min</th>
                  </tr>
                  <tr 
                    v-for="(row,index) in tableRows"
                    :key="index"  
                  >
                    <td>{{ row.studentsNum }}</td>
                    <td>{{ teacherWage(index) }}</td>
                    <td>{{ row.animatorWage }}</td>
                  </tr>
                </table>
              </li>
              <li>Z racji wykonywanych zajęć stacjonarnych w placówkach wskazanych przez Zleceniodawcę zgodnie z  § 2 ust.2 Zleceniobiorcy nie przysługuje dodatkowe wynagrodzenie z tytułu dojazdu oraz za dokonanie czynności dodatkowych związanych z przygotowaniem, organizacją i raportowaniem zajęć.</li>
              <li>Za realizację zajęć pokazowych stacjonarnych obowiązuje stawka bazowa.</li>
              <li>Za aktywnego uczestnika zajęć (zz) uważa się osobę obecną minimum na jednych zajęciach stałych, która jest aktywnym płatnikiem.</li>
              <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, 15-tego dnia następnego miesiąca kalendarzowego następującego po miesiącu rozliczenia, w wysokości określonej powyżej, w oparciu o zestawienie, o którym mowa w ust. 9 poniżej, na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
              <li>Całkowite miesięczne wynagrodzenie ustalone zostanie w oparciu o zestawienie i dokumentację, o których
mowa w ust. 8 niniejszego paragrafu. W przypadku zajęć stacjonarnych zastosowanie ma Tabela nr.1 Taryfikator stawek dla zajęć stacjonarnych w szkołach podstawowych w projekcie Back to School.</li>
              <li>Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej:
                <ol>
                  <li>zestawienia liczby godzin przepracowanych w danym miesiącu, wygenerowanego z narzędzi do ewidencjonowania godzin udostępnionego przez Zleceniodawcę, najpóźniej w ostatnim dniu roboczym miesiąca.</li>
                  <li>prowadzonej dokumentacji potwierdzającej realizację zajęć w danym miesiącu, w szczególności dzienników zajęć i list obecności uczniów, najpóźniej do ostatniego dnia miesiąca, za który Zleceniobiorcy przysługuje wynagrodzenie z tytułu wykonania zlecenia.</li>
                </ol>
                <span>Zweryfikowane przez Zleceniodawcę zestawienie i dokumentacja będą stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.</span>
              </li>
              <li>Zleceniodawca może obniżyć o kwotę do 15% wysokości wynagrodzenia brutto za dany miesiąc, w przypadku  niestosowania się do zapisów zawartych w umowie w szczególności: niedotrzymywania podanej 
               dyspozycyjności, spóźniania się na zajęcia, nie odpisywania na e-maile oraz nie odbierania telefonów od osób 
               wskazanych do kontaktu przez Zleceniodawcę, uzasadnionych skarg rodziców na jakość prowadzonych lekcji,
               niewywiązywania się z obowiązku oceniania dzieci w ramach raportów, nie zachowywania zasad kultury 
               osobistej na zajęciach oraz w kontakcie z osobami wskazanymi przez Zleceniodawcę, niewywiązywania się z 
               wytycznych dotyczących programu i jakości prowadzonych zajęć edukacyjnych określonych przez 
               Zleceniodawcę.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 7 Premia</strong>
            </p>
            <ol>
              <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową w wysokości do 15% wynagrodzenia brutto, której przyznanie jest uzależnione od stopnia realizacji przydzielonych zadań indywidualnych. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
              <li>Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową za inne cele niezwiązane z ust. 1 niniejszego paragrafu.</li>
              <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
              <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego, przelewem na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 8 Informacje poufne</strong>
            </p>
            <ol>
              <li>Przez Informacje Poufne strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy jego działalności i Klientów, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniodawcę, baza danych kontaktowych do Klientów Zleceniodawcy (w tym także klientów, którzy zakończyli współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania umowy.</li>
              <li>Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie do wykonania niniejszej umowy.</li>
              <li>Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.</li>
              <li>Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.</li>
              <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 5 000,00 zł (słownie: pięć tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową.</li>
              <li>Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.</li>
              <li>Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.</li>
              <li>Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy przez okres 5 lat.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px;">
      <strong>§ 9 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>

            <p align="center">
              <strong>§ 10 Doręczenia i korespondencja, zgoda na wykorzystanie wizerunku, RODO</strong>
            </p>
            <ol>
              <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
              <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
              <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku, zgodnie z załącznikiem do niniejszej umowy.</li>
              <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych   (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 11 Spory i sąd właściwy</strong>
            </p>
            <p>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</p>
            <br>

            <p align="center">
              <strong>§ 12 Kompletność oraz zmiana umowy</strong>
            </p>
            <ol>
              <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.
              </li>
              <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
              <li>Wszelkie zmiany niniejszej umowy wymagają formy dokumentowej pod rygorem nieważności.</li>
              <li>Rozwiązanie niniejszej umowy wymaga formy dokumentowej pod rygorem nieważności.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 13 Klauzula salwatoryjna</strong>
            </p>
            <p>
              Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.
            </p>
            <br>

            <p align="center">
              <strong>§ 14 Prawo właściwe</strong>
            </p>
            <ol>
              <li>Niniejsza umowa podlega prawu polskiemu.</li>
              <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
            </ol>
            <br>

            <p align="center">
              <strong>§ 15 Liczba egzemplarzy umowy</strong>
            </p>
            <p>Niniejsza umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
              <br>
            </p>
            <br>

            <div>
              <p class="underline">Załączniki stanowiące integralną część umowy:</p>
              <ol>
                <li class="underline">Upoważnienie do przetwarzania danych osobowych </li>
                <li class="underline">Informacja o monitoringu zajęć on - line</li>
                <li class="underline">Klauzula informacyjna Tutore Sp. z o.o.</li>
                <li class="underline">Oświadczenie Zleceniobiorcy</li>
                <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
                
              </ol>
            </div>

            <div class="cointainer" style="margin-top: 30px;">
              <div class="left-cointainer">
                <span style="margin-left: 0%;"><b>(Podpis Zleceniodawcy)</b></span>
                <br>
                <span style="margin-left: 0%;"><strong>{{ zamawiajacy }}</strong></span><br>
              </div>
              <div class="right-cointainer">
                <span style="margin-left: 0%;">(Podpis Zleceniobiorcy)</span>
                <br>
                {{ imieNazwisko }}
              </div>
            </div>
            <br>

            <div style="margin-top:5px;page-break-before: always;">
              <div class="cointainer" style="margin-top: 60px;">
                <div class="left-cointainer">
                  <p><em>Załącznik nr 1 Upoważnienie do przetwarzania danych osobowych</em></p>
                </div>
                <div class="right-cointainer">
                  <p style="margin-bottom: 10px; font-size: 14px;">
                    Łódź, dnia {{ aktualnaData() }} r.
                  </p>
                </div>
              </div>


              <p align="center" class="subheading" style="margin-bottom: 10px;">
                <strong>
                  Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji
                  papierowej i elektronicznej
                </strong>
              </p>
              <p class="p-margin">
                Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
              </p>
              <p class="p-margin">
                z dniem podpisania upoważnienia przez obie strony
              </p>
              <p class="p-margin">
                upoważniam Pana/Panią {{ imieNazwisko }} – Zleceniobiorcę Tutore Sp. z o.o. realizująca umowę zlecenie do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych: 
              </p>
              <p>
                w wersji elektronicznej:
              </p>
                <ol>
                  <li>
                    zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
                  </li>
                  <li>
                    zbiór danych osobowych Klientów: dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
- w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
                  </li>
                </ol>
              <p class="p-margin">
                Niniejszy dokument nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
              </p>
              <p>
                Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych.
              </p>
              <p>
                Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Sp. z o.o.. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
              </p>
              <p>
                Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
              </p>

              <div class="container" style="page-break-before: always;">
                <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
                      <ol>
                        <li>Ja niżej podpisany/a oświadczam, iż:
                          <ol type="a">
                            <li>
                              zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
                            </li>
                            <li>
                              treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący, 
                            </li>
                            <li>
                              zobowiązuję się do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
                            </li>
                            <li>
                              zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności
                            </li>
                            <li>
                              zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <div class="right-cointainer" style="float: right; margin-top: 20px;">
                        <span style="font-size: 14px;">{{ imieNazwisko }}</span>
                        <br>
                        <span>czytelny podpis Zleceniobiorcy</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

              <p class="subheading p-margin" style="text-align: center;">
                <strong>w imieniu Administratora</strong>
                <br>
                <span><strong>{{ zamawiajacy }} - upoważniona przez Administratora</strong></span>
              </p>
              <br>
              <p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.</p>
            </div>
            <div style="page-break-before: always;">
              <p><em>Załącznik nr 2 Informacja o monitoringu zajęć on-line</em></p>
              <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć online i
                  nagrywaniu szkoleń wewnętrznych online</strong></p>
              <br>
              Informujemy, iż Tutore Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on-line oraz nagrywania szkoleń wewnętrznych on-line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom. Tutore Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on-line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć on-line składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Sp. z o.o. , osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on-line i w toku nagrywania szkoleń wewnętrznych on-line jest Tutore Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych. Podmiotem świadczącym usługi w zakresie ww. monitoringu jest Tutore Sp. z o.o., z którą Tutore Sp. Z o.o. podpisała umowę powierzenia przetwarzania danych.
            </div>
            <div style="page-break-before: always; margin-top: 40px; font-size: 10px;">
              <p><em>Załącznik nr 3 Klauzula informacyjna Tutore Sp. z o.o.</em></p>
              <p align="right" style="font-size: 14px; margin-bottom: 0;">
                Łódź, dnia {{ aktualnaData() }} r.
              </p>
              <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
              <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
              <p align="center" class="subheading" style="margin-top: 100px;">
                <strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong>
              </p>
              <ol>
                <li>
                  Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000867745, NIP: 7272846163, tel. 500 965 135, info@tutore.eu
                </li>
                <li>
                  Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 13 i 14  Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
                </li>
                <li>
                  Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
                </li>
                <li>
                  Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
                  <ol type="a">
                    <li>
                      zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
                    </li>
                    <li>
                      wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
                    </li>
                    <li>
                      potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,
                    </li>
                    <li>
                      realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego
                    </li>
                    <li>
                      realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika składek na ubezpieczenie społeczne i zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,
                    </li>
                    <li>
                      realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
                    </li>
                    <li>
                      bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
                    </li>
                    <li>
                      zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
                    </li>
                    <li>
                      zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
                    </li>
                    <li>
                      zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
                    </li>
                    <li>
                      dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
                    </li>
                  </ol>
                </li>
                <li>
                  Odbiorcami Pani/Pana danych osobowych będą:
                  <ul>
                    <li>
                      organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;
                    </li>
                    <li>
                      zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
                    </li>
                    <li>
                      podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,
                    </li>
                    <li>
                      biura księgowe:
                    </li>
                    <li>
                      banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
                    </li>
                    <li>
                      kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z zajmowanym przez Zleceniobiorcę stanowiskiem pracy;
                    </li>
                    <li>
                      współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
                    </li>
                    <li>
                      podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.
                    </li>
                    <li>
                      instytucje ubezpieczeniowe
                    </li>
                    <li>
                      organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą) podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
                    </li>
                  </ul>
                </li>
                <li>
                  Ma Pani/Pan prawo do:
                  <ol type="a">
                    <li>
                      <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);
                    </li>
                    <li>
                      <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
                    </li>
                    <li>
                      <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);
                    </li>
                    <li>
                      <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);
                    </li>
                    <li>
                      <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
                      <ol type="i">
                        <li>
                          kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,
                        </li>
                        <li>
                          przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,
                        </li>
                        <li>
                          Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;
                        </li>
                        <li>
                          wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu. Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);
                    </li>
                    <li>
                      <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);
                    </li>
                    <li>
                      <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
                      <ul>
                        <li>
                          pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
                        </li>
                        <li>
                          elektronicznie za pośrednictwem platformy ePUAP.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
                <li>
                  W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.
                </li>
                <li>
                  Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
                </li>
              </ol>
            </div>

            <div style="page-break-before: always;">
              <div class="container">
                <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
                      <ol>
                        <li>Ja niżej podpisany/a oświadczam, iż:
                          <ol type="a">
                            <li>zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
                            <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
                          </ol>
                        </li>
                        <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
                        <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
                        <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
                      </ol>
                      <div style="float: right; margin-top: 20px;">
                        <span style="font-size: 14px;">{{ imieNazwisko }}</span>
                        <br>
                        <span>czytelny podpis Zleceniobiorcy</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </td>
        </tr>

      </tbody>
    </table>

    <div style="margin-top:5px;page-break-before: always;">
      <p><em>Załącznik nr 4</em></p>
      <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tbody>

          <tr>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
              <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
            </td>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Data</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ data }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ imieNazwisko }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Numer PESEL</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ pesel }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr
                  PESEL)</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nrDowodu }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ obywatelstwo }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Numer telefonu</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nrTelefonu }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Adres e-mail</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ email }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table">
                <span>Adres zamieszkania</span>
                <br>
                <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
              </p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table bigCell"><span>{{ zamieszkany }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table">
                <span>Adres korespondencyjny</span>
                <br>
                <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
              </p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ korespondencyjny }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table">
                <span>Urząd Skarbowy</span>
                <br>
                <span>(zgodny z adresem zamieszkania)</span>
              </p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table bigCell"><span>{{ urzadSkarbowy }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nrRachunku }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
            </td>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest
                    wymagany)</strong></span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ emeryt }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ rencista }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ orzeczenieNiepelnosprawnosc }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień
                  niepełnosprawności</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br> (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ student }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku
                  objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ chorobowe.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Sp. z o.o.<br> (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nazwaUmowaPraca }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore jest wyższe bądź równe krajowej płacy minimalnej:</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe<br> (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ wniosekUbezpieczenie }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa zlecenie z Tutore Sp. z o.o.<br> (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ ubezpieczenieUmowaPraca }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł
                  ubezpieczenia</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ tytulUbezpieczenieUmowaPraca }}</span></p>
            </td>
          </tr>

          <tr>
            <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table fs-14"><span><strong>
                Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
                <br />
                W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
                <br />
              </strong></span></p>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

    <div style="margin-top: 30px;page-break-before: always;">
      <p><em><b>Załącznik nr 5 Ogólne zasady bhp przy pracy administracyjno-biurowej</b></em></p>
      <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY
          ADMINISTRACYJNO-BIUROWEJ</strong></p>
      <br>
      <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
      <ul>
        <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).
        </li>
        <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
        <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie
          powinna być mniejsza niż 40%.</li>
        <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
        <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i
          innych urządzeń.</li>
      </ul>
      <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
      <ul>
        <li>Zaplanować kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
        <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
        <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
        <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i
          elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
        <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
      </ul>
      <p>Czynności, które należy wykonywać podczas pracy:</p>
      <ul>
        <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
        <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
      </ul>
      <p>Czynności zabronione:</p>
      <ul>
        <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
        <li>Otwierania osłon podczas pracy urządzeń.</li>
        <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja
          na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
      </ul>
      <p>Uwagi końcowe:</p>
      <ul>
        <li>
          Przy stałej pracy przy komputerze należy:
          <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi
              narządu wzroku i wykonywanymi w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy
              przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora
              ekranowego.</li>
          </ul>
        </li>
      </ul>
      <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy
        administracyjno-biurowej.</p>
      <div style="margin-top: 40px; font-size: 10px;">
        <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
        <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
      </div>
    </div>


  </v-container>
</template>

<script>
export default {
  name: 'UmowaNauczycielLektorAnimatorTutoreMale',
  data() {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      dobrowolneUbezpieczenie: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      kwota1: '',
      kwota2: '',
      kwota3: '',
      slownie: '',
      slownie1: '',
      slownie2: '',
      slownie3: '',
      usluga: '',
      usluga2: '',
      usluga3: '',
      wypo: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      przedmiot: '',
      miejscowosc: '',
      kodPocztowy: '',
      wniosekUbezpieczenie: '',
      tableRows: [
        { studentsNum: 'zajęcia pokazowe', animatorWage: '30'},
        { studentsNum: '1-5', animatorWage: '30'},
        { studentsNum: '6', animatorWage: '35'},
        { studentsNum: '7', animatorWage: '40'},
        { studentsNum: '8', animatorWage: '45'},
        { studentsNum: '9', animatorWage: '50'},
        { studentsNum: '10', animatorWage: '55'},
        { studentsNum: '11', animatorWage: '60'},
        { studentsNum: '12', animatorWage: '65'},
        { studentsNum: '13', animatorWage: '70'},
        { studentsNum: '14', animatorWage: '75'},
        { studentsNum: '15 i więcej', animatorWage: '80'},
      ],
      stawka: '',
      stawkaSlownie: '',
    }
  },
  created() {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    teacherWage(index) {
      if (this.stawka.includes('-')) {
        return this.stawka;
      }
      return index > 1 ? `${Number(this.stawka) + 5 * (index - 1)} zł` : `${this.stawka} zł`;
    },
    shortNrUmowy() {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch (tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'NauczycielAnimatorLektor':
          shortPosition = 'NauAnimLek'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'Twórca':
          shortPosition = 'Tworca'
          break
        case 'TwórcaMateriałów':
          shortPosition = 'TMat'
          break
        case 'TwórcaFabrykaMateriałów':
          shortPosition = 'TFabMat'
          break
        case 'TwórcaMateriałówNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'MetodykTwórcaNauczyciel':
          shortPosition = 'MetTworcaNau'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        case 'TworcaFabrykaMaterialow':
          shortPosition = 'TFabMat'
          break
        default:
          shortPosition = tab[3]
      }
      let shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      if (tab.length > 6) {
        shortUmowa += `/${tab[6]}`
      }
      return shortUmowa
    },
    slownieAngielski() {
      switch (this.kwota) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slownie
      }
    },
    slowniePokazAngielski() {
      switch (this.kwotapokaz) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slowniepokaz
      }
    },
    dataObowiazywaniaUmowyPolski() {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'dnia podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    dataObowiazywaniaUmowyAngielski() {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'the day of its conclusion'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
        return 'Marcin Grzelak - Chairman of the Board'
      } else {
        return this.zamawiajacy
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if ((day + 1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth() + 1;
      if ((today.getMonth() + 1) < 10) {
        month = '0' + month
      }
      const todayDate = day + '-' + month + '-' + today.getFullYear()
      return todayDate
    }
  },
  mounted() {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th,
td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

.fs-14 {
  font-size: 14px;
}

.wage-table {
  border: 1px solid; 
  font-size: 12px; 
  width: 65%;
  margin: 20px;
}

.wage-table caption {
  text-align: left; 
}

.wage-table td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  font-weight: bold;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaNauczycielLektorAnimatorTutoreMale.vue